import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { $params } from '../../../../features/router'
import { DividendEvent } from './types'

export const dividendEventMounted = createEvent()
export const setDividendEvent = createEvent<DividendEvent>()
export const $dividendEvent = restore(setDividendEvent, {
  dividendEventID: '',
  stage: 0,
  paymentDate: '',
  status: '',
  type: '',
  amount: '',
  annualDividends: '',
  feeTotal: '',
  fees: [
    {
      Value: '',
      Name: '',
      Type: '',
    },
  ],
  propertyId: '',
  name: '',
  tokenAmount: '',
  propertyPrice: '',
  investmentStrategy: {
    type: '',
    name: '',
  },
  stages: 0,
  updatedByUsername: '',
  createdAt: '',
  updatedAt: '',
  appreciationDividendInfo: {
    totalNetValue: '',
    finalPropertyPrice: '',
    appreciationFeeValue: '',
    initialPropertyPrice: '',
    appreciationFeePercent: '',
    finalPropertyAppreciation: '',
  },
})

export const getDividendEvent = fx<void, DividendEvent>({
  method: 'GET',
  url: `/nova/dividend_event`,
})

sample({
  clock: dividendEventMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.dividendEventID
    }
    return {
      url: `/nova/dividend_event/${id}`,
    }
  },
  target: getDividendEvent,
})

sample({
  clock: getDividendEvent.doneData,
  fn: (doneData) => doneData.body,
  target: setDividendEvent,
})
